import { QualityControlWorkOrder } from '../../../common/quality-control/model/work-order-qc.ts';
import { Inspection } from '../../../api/elite/types/inspections';
import { SubWorkOrder } from '../../../api/elite/types/sub-work-order';
import { AssemblyItem } from '../../../api/elite/types/assembly-item';
import { SchedulerWorkOrder } from '../../../common/scheduler/models/work-order';

export class HosesWorkOrder extends QualityControlWorkOrder {
  currentInspection: Inspection;
  quantityToApprove: number;

  get labTestsToDo(): { id: number; title: string }[] {
    return this.currentInspection?.testRecords?.map((el) => el.testType);
  }

  get itemIdForInspection(): number {
    return this.workOrderId;
  }

  get quantityOnQc(): number {
    return this.qcSubWorkOrder?.quantity || 0;
  }

  set quantityOnQc(val: number) {
    if (this.qcSubWorkOrder) {
      this.qcSubWorkOrder.quantity = val;
    }
  }

  get quantityRequiredPlus10(): number {
    return Math.floor(this.quantityRequired * 1.1);
  }

  get producedPlusOnValidation(): number {
    return this.builtReport + this.quantityPacked;
  }

  get quantityToDo(): number {
    const val = this.quantityRequiredPlus10 - this.producedPlusOnValidation;
    return val > 0 ? val : 0;
  }

  get pendingToApprove(): number {
    return this.quantityToApprove || 0;
  }

  get quantityFinished(): number {
    return this.quantityBuilt + this.quantityToApprove;
  }

  get quantityProduced(): number {
    return this.trimmingQuantity + this.qcQuantity + this.builtReport;
  }

  /**
   * quantity from machines
   */
  get quantityProcess(): number {
    return this.subWorkOrders.reduce(
      (total, el) => total + (el?.quantity || 0),
      0
    );
  }

  get assemblyTitle(): string {
    return this.assemblyItem.title;
  }

  get assemblyType(): string {
    if (
      !this.assemblyItem?.typesList ||
      this.assemblyItem?.typesList?.length === 0
    ) {
      return '';
    }
    return this.assemblyItem?.typesList[0]?.title || '';
  }

  get trimmingQuantity(): number {
    return (
      this.subWorkOrders.find((el) => el?.stage?.title === 'Trimming')
        ?.quantity || 0
    );
  }

  get qcQuantity(): number {
    return (
      this.subWorkOrders.find((el) => el?.stage?.title === 'Quality Control')
        ?.quantity || 0
    );
  }

  qcSubWorkOrder: SubWorkOrder;
  assemblyItem: AssemblyItem;
  quantityRequired: number;
  quantityBuilt: number;
  builtReport: number;
  quantityPacked: number;
  scrap: number;

  hasRequiredQuantity: boolean;
  salesOrder = '';
  salesOrders: string[] = [];

  static fromObject(object: Partial<SchedulerWorkOrder>): HosesWorkOrder {
    const workOrder = new HosesWorkOrder();
    Object.assign(workOrder, object);
    return workOrder;
  }

  compareItemName(itemName: string): boolean {
    return this.assemblyItem.title === itemName;
  }
}
